import React, { useEffect, useState } from 'react';
import { TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import { AUTHORITY_NAMES } from 'web-library/models/AuthorityFunctions';
import { useHistory } from 'react-router-dom';
import AdminFeatureConfiguration from '../../modules/admin/components/AdminFeatureConfiguration';
import RouteKey from '../../routes/key';
import { useGetUserAuthorities } from '../../api-refactored/user/useGetUserAuthorities';
import LoadingComponent from '../../components/LoadingComponent';

const { error } = RouteKey.child;
const { generic } = RouteKey.error.child;

const FeaturesConfiguration = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [hasView, setHasView] = useState<boolean>(false);

  const { data: userAuthoritiesData = [], isSuccess: isGetAuthoritiesSuccess } = useGetUserAuthorities();

  useEffect(() => {
    if (isGetAuthoritiesSuccess) {
      if(!userAuthoritiesData.includes(AUTHORITY_NAMES.CP_ADMIN_FEATURES_CONFIGURATION_VIEW)) {
      history.push(`/${error}/${generic}`);
      } else {
        setHasView(true);
      }
    }
  }, [history, userAuthoritiesData, isGetAuthoritiesSuccess]);

  return (
    <>
      <TitleHeader title={t('admin->>FeaturesConfiguration.Features Configuration')} />
      {hasView ? <AdminFeatureConfiguration /> : <LoadingComponent />}
    </>
  );
};

export default FeaturesConfiguration;
